import { Text, Sidebar, Cell } from '@taxdown/piccolo-web';
import { IconType } from '@taxdown/piccolo-web/dist/types/common';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { useTranslation } from 'Hooks/useTranslation';
import { TAX_YEAR } from 'Config';
import { handleSidebarMenu } from 'Styles/utils/utils';
import * as Styled from './styles';
import { MenuViewProps } from './types';
import Row from './components/Row';

const View = ({
  filterLinks,
  isPathActive,
  isRouteCompleted,
  isDisabled,
}: MenuViewProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.VALIDATIONS);

  return (
    <Styled.NavStyled className="Menu">
      <Sidebar>
        {filterLinks.length > 0 && (
          <Text type="headline" size="L_S_L" color="dark" mb="fds_size_16">
            {t('Menu.title', { taxYear: TAX_YEAR })}
          </Text>
        )}
        {filterLinks.map(({ route, label, icon, sectionId }, index) => (
          <Cell
            key={label}
            size="M"
            onClick={() => {
              handleSidebarMenu();
              history.push(route);
            }}
            isSelected={isPathActive(sectionId)}
            isDisabled={isDisabled(filterLinks, index)}
          >
            <Row
              label={t(label)}
              icon={icon as IconType}
              isRouteCompleted={() => isRouteCompleted(filterLinks, index)}
            />
          </Cell>
        ))}
      </Sidebar>
    </Styled.NavStyled>
  );
};

export default View;
